// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var TicketComment$ReactHooksTemplate = require("./ticketComment.res.js");

function TicketCommentView(props) {
  var activity = props.activity;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Comment Added",
                              className: "text-sm font-semibold"
                            }),
                        JsxRuntime.jsx("div", {
                              children: TicketComment$ReactHooksTemplate.user_email(activity),
                              className: "text-xs font-normal"
                            })
                      ],
                      className: "flex justify-between text-darkcharcoal"
                    }),
                JsxRuntime.jsx("div", {
                      children: TicketComment$ReactHooksTemplate.comment(activity),
                      className: "mt-2 text-xs font-normal"
                    })
              ]
            });
}

var make = TicketCommentView;

exports.make = make;
/* react/jsx-runtime Not a pure module */
